export const sampleFlyers = [
  {
    id: 1,
    title: 'Custom Photo Collage Printing',
    category: 'Offers',
    feedType: 'offers',
    location: 'Little Elm, TX',
    address: 'Little Elm, TX',
    date: 'Jun 12',
    saved: true,
    status: 'Published',
    image: 'https://dummyimage.com/720x960/f8ead7/102a56&text=Custom+Photo+Collage+Printing',
    author: 'Printify Studio',
    description: 'Custom mouse pad printing starting from $10 and metal prints for family photos, travel memories, and wall decor.'
  },
  {
    id: 2,
    title: 'Designers Market',
    category: 'Market place',
    feedType: 'marketplace',
    location: 'Brooklyn, NY',
    address: 'Dumbo Market Hall, Brooklyn, NY',
    date: 'Jun 18',
    saved: false,
    status: 'Draft',
    image: 'https://dummyimage.com/720x840/f59e0b/ffffff&text=Designers+Market',
    author: 'Studio North',
    description: 'Independent makers, print artists, home goods, and limited edition apparel.'
  },
  {
    id: 3,
    title: 'Open Air Film Night',
    category: 'Events',
    feedType: 'events',
    location: 'San Diego, CA',
    address: 'Waterfront Park, San Diego, CA',
    date: 'Jul 02',
    saved: true,
    status: 'Published',
    image: 'https://dummyimage.com/720x900/2563eb/ffffff&text=Open+Air+Film+Night',
    author: 'NetFlyr Team',
    description: 'Community screening with reserved lawns, snacks, and pre-show trivia.'
  },
  {
    id: 4,
    title: '30 System Design Concepts',
    category: 'Inspiration',
    feedType: 'inspiration',
    location: 'Remote',
    address: 'Online workshop',
    date: 'Jul 08',
    saved: false,
    status: 'Published',
    image: '',
    accent: '#8799aa',
    author: 'Architecture Lab',
    description: 'Every developer should know client-server architecture, load balancing, caching, queues, and database scaling basics.'
  },
  {
    id: 5,
    title: 'Weekend Taco Pop-up',
    category: 'Menus & lists',
    feedType: 'menus',
    location: 'Austin, TX',
    address: 'East 6th Street, Austin, TX',
    date: 'Jul 12',
    saved: false,
    status: 'Published',
    image: 'https://dummyimage.com/720x820/ef4444/ffffff&text=Weekend+Taco+Pop-Up',
    author: 'Maya Chen',
    description: 'A weekend tasting menu with local chefs, live music, agua frescas, and late evening desserts.'
  },
  {
    id: 6,
    title: 'Grand Opening Specials',
    category: 'Announcement',
    feedType: 'announcement',
    location: 'Little Elm, TX',
    address: 'Main Street Plaza, Little Elm, TX',
    date: 'Jul 15',
    saved: true,
    status: 'Published',
    image: '',
    accent: '#14b8a6',
    author: 'Northside Wellness',
    description: 'Opening week specials for wellness consultations, massage therapy, and family care packages.'
  },
  {
    id: 7,
    title: 'Community Art Walk',
    category: 'Events',
    feedType: 'events',
    location: 'Brooklyn, NY',
    address: 'Wythe Avenue, Brooklyn, NY',
    date: 'Jul 20',
    saved: false,
    status: 'Published',
    image: 'https://dummyimage.com/720x980/8b5cf6/ffffff&text=Community+Art+Walk',
    author: 'Local Creatives',
    description: 'Gallery stops, live mural sessions, pop-up prints, and neighborhood food vendors.'
  },
  {
    id: 8,
    title: 'Hiring Baristas',
    category: 'Jobs',
    feedType: 'jobs',
    location: 'San Diego, CA',
    address: 'North Park, San Diego, CA',
    date: 'Jul 22',
    saved: false,
    status: 'Published',
    image: '',
    accent: '#f97316',
    author: 'Harbor Coffee',
    description: 'Morning and weekend shifts available for friendly baristas. Training included and local applicants welcome.'
  },
  {
    id: 9,
    title: 'Yoga Batch Enrollment',
    category: 'Offers',
    feedType: 'offers',
    location: 'Austin, TX',
    address: 'Zilker Studio, Austin, TX',
    date: 'Jul 25',
    saved: true,
    status: 'Published',
    image: 'https://dummyimage.com/720x760/16a34a/ffffff&text=Yoga+Batch+Enrollment',
    author: 'Zilker Flow',
    description: 'Beginner-friendly morning and evening yoga batches with weekly flexibility workshops.'
  },
  {
    id: 10,
    title: 'Local Book Swap',
    category: 'Reviews',
    feedType: 'reviews',
    location: 'Remote',
    address: 'Online signup, local pickup',
    date: 'Jul 28',
    saved: false,
    status: 'Published',
    image: '',
    accent: '#ec4899',
    author: 'Readers Circle',
    description: 'Trade books with nearby readers, reserve pickup windows, and discover community recommendations.'
  },
  {
    id: 11,
    title: 'Storm Watch Notice',
    category: 'Alerts',
    feedType: 'alerts',
    location: 'Austin, TX',
    address: 'Travis County, Austin, TX',
    date: 'Jul 30',
    saved: false,
    status: 'Published',
    image: '',
    accent: '#dc2626',
    author: 'Community Desk',
    description: 'Weather alert with shelter locations, road closure notes, and emergency contact reminders.'
  },
  {
    id: 12,
    title: 'Studio Apartment Available',
    category: 'Property',
    feedType: 'property',
    location: 'Brooklyn, NY',
    address: 'Greenpoint, Brooklyn, NY',
    date: 'Aug 01',
    saved: false,
    status: 'Published',
    image: 'https://dummyimage.com/720x860/0891b2/ffffff&text=Studio+Apartment+Available',
    author: 'Harbor Rentals',
    description: 'Bright studio apartment near transit, groceries, and cafes. Open viewing slots this weekend.'
  }
]

export const categories = ['All', 'Offers', 'Events', 'Menus & lists', 'Jobs', 'Reviews', 'Alerts', 'Property', 'Market place', 'Announcement', 'Inspiration']
